// extracted by mini-css-extract-plugin
export const mainSection = "course-module--mainSection--1N3XW";
export const contentWrap = "course-module--contentWrap--1cxbJ";
export const content = "course-module--content--a34ri";
export const wrapper = "course-module--wrapper--3QQGk";
export const form = "course-module--form--3gfEQ";
export const features = "course-module--features--2C0fb";
export const subscribe = "course-module--subscribe--29hBY";
export const componentWrapper = "course-module--componentWrapper--1pfeA";